export const SET_COMPLIANCE_MANAGEMENT_ACTIVE_GROUPS = 'SET_COMPLIANCE_MANAGEMENT_ACTIVE_GROUPS'
export const SET_COMPLIANCE_MANAGEMENT_REINITIALIZE = 'SET_COMPLIANCE_MANAGEMENT_REINITIALIZE'

export function setComplianceManagementActiveGroups (value) {
  return {
    type: SET_COMPLIANCE_MANAGEMENT_ACTIVE_GROUPS,
    payload: value,
  }
}

export function setComplianceManagementReinitialize () {
  return {
    type: SET_COMPLIANCE_MANAGEMENT_REINITIALIZE,
  }
}
